import { Component, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { EmployeeView } from '../../../../shared/sdk';

@Component({
  selector: 'app-employee',
  templateUrl: './employee-perf.component.html',
  styleUrls: ['./employee-perf.component.scss'],
})
export class EmployeePerfComponent implements OnInit {
  $selectedIds$: BehaviorSubject<number[]> = new BehaviorSubject([]);
  $selectedRanges$: BehaviorSubject<any> = new BehaviorSubject({});
  selectedId$: Observable<number> = new Observable();
  selectedRange$: Observable<any> = new Observable();

  constructor() {
    this.selectedId$ = this.$selectedIds$.pipe(map(ids => (ids && ids.length ? ids[0] : null)));
    this.selectedRange$ = this.$selectedRanges$.pipe(map(range => range));
  }

  ngOnInit() {}

  list_onSelected(items: EmployeeView[]) {
    if (items && items.length) {
      this.$selectedIds$.next(items.map(item => item.id));
    } else {
      this.$selectedIds$.next([]);
    }
  }

  range_onSelected(range: any) {
    this.$selectedRanges$.next(range);
  }

  split_dragEnd(e) {
    // dxEvents.trigger(window, 'resize');
  }

  split_transitionEnd(e) {
    // dxEvents.trigger(window, 'resize');
  }
}
